// src/components/CommonSnackbar/SnackbarProvider.js
import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import { Snackbar, Slide, LinearProgress } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Grow, Fade } from "@material-ui/core";

const SnackbarContext = createContext(null);

export const useSnackbar = () => useContext(SnackbarContext);

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}
function GrowTransition(props) {
  return <Grow {...props} />;
}

function FadeTransition(props) {
  return <Fade {...props} />;
}

export const SnackbarProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [snackbarData, setSnackbarData] = useState({
    message: "",
    severity: "success",
  });
  const [progress, setProgress] = useState(100);
  const duration = 3000; // ms

  const showSnackbar = useCallback((message, severity = "  ") => {
    setSnackbarData({ message, severity });
    setProgress(100); // reset progress
    setOpen(true);
  }, []);

  // Progress bar animation
  useEffect(() => {
    if (open) {
      const interval = 50; // update every 50ms
      const step = (100 / duration) * interval;

      const timer = setInterval(() => {
        setProgress((old) => Math.max(old - step, 0));
      }, interval);

      return () => clearInterval(timer);
    }
  }, [open, duration]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}

      <Snackbar
        open={open}
        autoHideDuration={duration}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={SlideTransition}
      >
        <div style={{ width: "100%" }}>
          <Alert
            onClose={handleClose}
            severity={snackbarData.severity}
            variant="filled"
            style={{ borderRadius: "8px 8px 0 0" }}
          >
            {snackbarData.message}
          </Alert>
          {/* Loader line */}
          <LinearProgress
            variant="determinate"
            value={progress}
            color={snackbarData.severity === "error" ? "secondary" : "primary"}
            style={{ height: 4, borderRadius: "0 0 8px 8px" }}
          />
        </div>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
